import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "../../axiosServices";
import QueryGlobalInterface from "../../../interfaces/queryInterface";

export interface useListarUsuariosPorEquipeInterface {
  IdUsuarioLider?: string;
}

export function useListarUsuariosPorEquipeGerente(
  props: useListarUsuariosPorEquipeInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const hasIdUsuarioLider = props.IdUsuarioLider
      ? (props.IdUsuarioLider = `&idUsuarioLider=${props.IdUsuarioLider}`)
      : "";
    const LISTAR_USUARIOS_POR_EQUIPE = `identity/usuario/v1/listar-usuarios-corretor-destino-transferencia?${hasIdUsuarioLider}`;
    const response = await instance.get(LISTAR_USUARIOS_POR_EQUIPE);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 2,
    cacheTime: 0,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar usuarios por equipe. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
